var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-thumb",style:(_vm.boxStyle),attrs:{"aria-label":_vm.alt,"role":"img"}},[_c('img',{staticClass:"product-thumb__img",attrs:{"src":_vm.imgSrc,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }